<script setup lang="ts">
import { toRef } from 'vue';
import { PageFooter } from '@/components/clients/common';
import LangChooser from '@/components/common/LangChooser.vue';
import { useEventStore } from '@/stores/event/event.store';
import SenderWidget from '@/components/clients/event/SenderWidget.vue';
import FrontImage from '@/components/clients/event/FrontImage.vue';
import FrameHeader from '@/components/clients/event/FrameHeader.vue';
import { useStateStore } from '@/stores/state.store';

const eventStore = useEventStore();
const stateStore = useStateStore();

const mainColor = toRef(() => stateStore.getColors.mainColor);
const backgroundColor = toRef(() => stateStore.getColors.backgroundColor);
const textFont =
  eventStore.getCommonData.textFont &&
  eventStore.getCommonData.textFont.trim() !== ''
    ? eventStore.getCommonData.textFont
    : 'Petit Formal Script';

const underPictureText = toRef(() =>
  eventStore.getLangData('underPictureText'),
);
</script>

<template>
  <div
    class="background"
    :style="{
      background: `url(${eventStore.getImages?.background?.url}) no-repeat center center / cover, ${backgroundColor}`,
    }"
  >
    <LangChooser
      :main-color="mainColor"
      :background-color="backgroundColor"
      :store="eventStore"
    />
    <div class="main-page">
      <div class="main-border">
        <div class="main">
          <FrameHeader />
          <FrontImage />
          <div class="text">
            <h2 v-if="underPictureText" class="core-default-h2 custom-font">
              {{ underPictureText }}
            </h2>
            <h2 v-else class="core-default-h2 custom-font">
              {{ $t('appCore.apps.event.common.underPictureText') }}
            </h2>
          </div>
          <SenderWidget
            :sending-text="$t('appCore.apps.event.mirrorWedding.sendingText')"
            :send-text="$t('appCore.apps.event.mirrorWedding.sendText')"
          />
          <div class="foot core-default-h4">2025</div>
        </div>
      </div>
    </div>
    <PageFooter />
  </div>
</template>

<style lang="scss" scoped>
.main-border {
  background-attachment: fixed;
  position: relative;
  margin: auto;
  margin-bottom: 45px;
  max-width: 900px;
  width: 70%;
  padding: 25px;
  border: 2px solid v-bind(backgroundColor);
  border-radius: 36px;

  @media screen and (max-width: 768px) {
    width: 90%;
  }

  .main {
    color: v-bind(mainColor);
    background: v-bind(backgroundColor);
    border-radius: 24px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;

    @media screen and (max-width: 500px) {
      gap: 10px;
    }

    .text {
      text-align: center;
      width: 80%;
      margin: auto;
    }

    .foot {
      color: v-bind(mainColor);
      font-size: 2em;
      margin: 0 auto 10px;

      @media screen and (max-width: 500px) {
        font-size: 1.5em;
        line-height: 1.5em;
        margin: 0 auto 5px;
      }
    }
  }
}

.main-page {
  margin: auto;
  position: relative;
  padding-top: 80px;

  @media screen and (max-width: 500px) {
    padding-top: 30px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
}

.custom-font {
  font-family: v-bind(textFont), 'Petit Formal Script', serif;
}
</style>
